import { FetchHelper } from '@yulintu/freesia-core';
import sso from "freesia-sso";
import { Modal, Button, Collapse } from 'antd'
import { parseResultToJson } from './helper';
import React, { Component } from 'react';
import { customGlobal } from './global';

class AutoReportPromise {
    constructor(options) {
        this.promise = new Promise(options);
    }
    then(onResolve, onReject) {
        this.promise = this.promise.then(onResolve, onReject);
        return this;
    }
    catch(func) {
        this.promise = this.promise.catch(func);
        return this;
    }
    finally(func) {
        this.promise = this.promise.finally(func);
        return this;
    }
    autoReport(func) {
        this.enbledAutoReport = true;
        if (func) {
            this.promise.catch(func);
        }
        return this;
    }
    notAutoReport(func) {
        this.enbledAutoReport = false;
        if (func) {
            this.promise.catch(func);
        }
        return this;
    }
}

class API {
    //login
    static logout(params, callback) {
        sso.logout(params, callback)
    }
    static globalLogoutModal = null;
    static confirmlogout() {
        let secondsToGo = 20;
        if (!this.globalLogoutModal) {
            let modal = this.globalLogoutModal = Modal.confirm({
                title: '重新登陆',
                content: "登陆过期，请重新登陆",
                okText: `去登陆(${secondsToGo}S)`,
                onOk: () => {
                    clearInterval(timer);
                    this.logout({
                        autoRedirect: false
                    }, () => {
                        this.globalLogoutModal = null;
                        window.open(window.location.href, '_blank');
                    });
                },
                cancelText: "取消",
                onCancel: () => {
                    this.globalLogoutModal = null;
                    clearInterval(timer);
                },
                zIndex: 9999
            });
            let timer = setInterval(() => {
                if (secondsToGo === 0) {
                    clearInterval(timer);
                    this.logout({
                        autoRedirect: false
                    }, () => {
                        window.open(window.location.href, '_blank');
                    });
                } else {
                    secondsToGo -= 1;
                    modal.update({
                        okText: `去登陆(${secondsToGo}S)`
                    });
                }
            }, 1000);
        }
    }
    static handleError(responseData) {
        if (responseData.status === 401) {
            this.confirmlogout()
            return true
        } else if (responseData.status === 511) {
            let msg = (responseData.message || '').replace('ApiException: ', '');
            Modal.confirm({
                title: '授权错误',
                content: msg + "，请去授权页面完成软件授权。",
                okText: `确定`,
                cancelText: "取消",
                onOk: () => {
                    window.open("/license", '_self');
                },
            })
        } else if (responseData.status !== 200) {
            let msg = (responseData.message || '').replace('ApiException: ', '');
            Modal.error({
                width: 500,
                title: '错误',
                content: <div className="public-error-content">
                    <div>{msg}</div>
                    <Collapse expandIcon={e => {
                        return <span></span>;
                    }} style={{
                        border: 0
                    }}>
                        <Collapse.Panel style={{
                            border: 0
                        }}
                            header={<Button style={{
                                padding: 0
                            }} type="link">详情</Button>}>{typeof (responseData.data) === 'string' ? responseData.data : JSON.stringify(responseData.data)}</Collapse.Panel>
                    </Collapse>
                </div>
            })
        }
        return false
    }
    static _requestJson(action, url, body) {
        let promise = new AutoReportPromise((resolve, reject) => {
            FetchHelper[action](url, body)
                .then(json => {
                    if (json.status === 200) {
                        resolve(json.data)
                    } else {
                        reject(this.errorMeaasge(json.message))
                    }
                }).catch(error => {
                    if (promise.enbledAutoReport !== false) {
                        this.handleError(error);
                    }
                    reject(this.responseError(error))
                })
        });
        return promise;
    }
    //base
    static getJson(url, body) {
        return this._requestJson('getJson', url, body)
    }
    static putJson(url, body) {
        return this._requestJson('putJson', url, body)
    }
    static postJson(url, body) {
        return this._requestJson('postJson', url, body)
    }
    static deleteJson(url, body) {
        return this._requestJson('deleteJson', url, body)
    }

    static getDataTransferTableMetadata(dsId, schema, table, sourceQuery) {

        let path = "/api/ds/dy/columns";
        let body = {
            dsId,
            schemaName: schema,
            tableName: table,
            sql: sourceQuery,
        }

        return this.postJson(path, body).then(data => {

            if (!data || !data.length)
                return null;

            const cols = [];
            const meta = { cols };

            data.forEach(col => {
                let nc = {
                    name: col.name,
                    type: col.fieldType,
                    size: col.size,
                    decimalDigits: col.decimalDigits,
                    nullable: col.nullable,
                    primary: col.primary,
                }

                cols.push(nc);

                if (nc.type === "Geometry") {
                    meta.srid = col.srid;
                    meta.geometryType = col.spatialType;
                }
            });

            return meta;
        });
    }

    static getDataTransferTableMetadataForTarget(dsId, schema, table) {

        if (!table)
            table = null;

        let path = "/api/ds/dy/columns";
        let body = {
            dsId,
            schemaName: schema,
            tableName: table,
        }

        return this.postJson(path, body).then(data => {

            if (!data || !data.length)
                return null;

            const cols = [];
            const meta = { cols };

            data.forEach(col => {
                let nc = {
                    name: col.name,
                    type: col.fieldType,
                    size: col.size,
                    decimalDigits: col.decimalDigits,
                    nullable: col.nullable,
                    primary: col.primary,
                }

                cols.push(nc);

                if (nc.type === "Geometry") {
                    meta.srid = col.srid;
                    meta.geometryType = col.spatialType;
                }
            });

            return meta;
        }, err => {
            return null;
        });
    }

    static deleteDataScreenDocument(id) {
        return this.deleteJson("/api/bi/entity/" + id);
    }
    static getDataScreenDocument(id) {
        return this.getJson("/api/bi/entity/" + id);
    }
    static listDataScreenDocuments(access) {
        return this.getJson("/api/bi/list/" + (access ? "private" : "public"));
    }
    static addDataScreenDocument(name, json, opts) {
        opts.name = name;
        opts.content = json;
        return this.postJson("/api/bi/entity", opts);
    }
    static saveDataScreenDocument(id, json, opts) {
        opts.id = id;
        opts.content = json;
        return this.putJson("/api/bi/entity", opts);
    }
    // static addConfig(name, type, value, opts) {
    //     opts.name = name;
    //     opts.type = type;
    //     opts.value = value;
    //     return this.postJson("/api/config/entity", opts);
    // }
    // static saveConfig(id, value, opts) {
    //     opts.id = id;
    //     opts.value = value;
    //     return this.putJson("/api/config/entity", opts);
    // }
    // static getConfig(id) {
    //     return this.getJson("/api/config/entity/" + id);
    // }
    // static listConfig(access) {
    //     return this.getJson("/api/config/list/" + (access ? "private" : "public"));
    // }
    // static deleteConfig(id) {
    //     return this.deleteJson("/api/config/entity/" + id);
    // }
    //mydata
    static getMyDataList() {
        return this.getJson("/api/storage/list")
    }
    static getMyData(id, pageIndex, pageSize) {
        return this.getJson(`/api/storage/data/${id}?page=${pageIndex}&size=${pageSize}`)
    }
    static getMyDataCount(id) {
        return this.getJson(`/api/storage/data/${id}/count`)
    }
    static deleteMyData(id) {
        return this.deleteJson(`/api/storage/data/${id}`)
    }
    static changeMyDataTableName(id, tableName) {
        return this.postJson(`/api/storage/data/${id}?tableName=${tableName}`)
    }
    static getMyDataColumns(id) {
        return this.getJson(`/api/storage/data/${id}/columns`)
    }
    static startMyDataSpatialization(id, col, type, srid) {
        return this.getJson(`/api/storage/data/${id}/spatial?column=${col}&type=${type}&srid=${srid}`)
    }
    static startTestTask() {
        return this.postJson(`/api/task/test/start`, {})
    }
    static getDataSourceList() {
        return this.getJson('/api/ds/list')
    }
    static getDataSourceExecutor(typeName) {
        return this.getJson(`/api/ds/executor/support/details?typeName=${typeName || ''}`)
    }
    static getExecutorParams(exeName) {
        return this.getJson(`/api/ds/executor/def?exeName=${exeName}`)
    }
    static getDataSource(id) {
        return this.getJson(`/api/ds/entity/${id}`)
    }
    static deleteDataSource(id) {
        return this.deleteJson(`/api/ds/entity/${id}`)
    }
    static deleteAllDataSource(ids) {
        return this.deleteJson('/api/ds/entity', ids)
    }
    static getDataSourceType() {
        return this.getJson('/api/ds/support')
    }
    static getDataSourceCreateParams(typeName) {
        return this.getJson(`/api/ds/def?typeName=${typeName}`)
    }
    static getDataSourceAttr(id) {
        return this.getJson(`/api/ds/attr/${id}`)
    }
    static createDataSource(typeName, params) {
        return this.postJson(`/api/ds/create?typeName=${typeName}`, params)
    }
    static updateDataSourceAttr(id, params) {
        return this.putJson(`/api/ds/attr/${id}`, params)
    }
    static updateDataSourceAccess(id, access) {
        return this.putJson("/api/ds/entity/field", { id, access })
    }
    static addDatasourceVisitor(entity) {
        return this.postJson("/api/ds/per/entity", entity)
    }
    static addDatasourceVisitors(dsId, userKeys, rolekeys) {
        let entities = [];
        if (userKeys)
            for (const userKey of userKeys) {
                entities.push({
                    data_id: dsId,
                    visitor: userKey,
                    visitor_type: 2,
                    access: 1
                })
            }
        if (rolekeys)
            for (const roleKey of rolekeys) {
                entities.push({
                    data_id: dsId,
                    visitor: roleKey,
                    visitor_type: 1,
                    access: 1
                })
            }
        return this.postJson("/api/ds/per/batch", entities)
    }
    static deleteDatasourceVisitors(rows) {
        return this.deleteJson("/api/ds/per/entity", rows)
    }
    static getDatasourcePermissionList(dsId) {
        return this.getJson("/api/ds/per/list", { dataId: dsId })
    }
    //Process
    static getProcessList() {
        return this.getJson('/api/ps/list')
    }
    static getProcess(id) {
        return this.getJson(`/api/ps/entity/${id}`)
    }
    static createProcess(params) {
        return this.postJson('/api/ps/entity', params)
    }
    static deleteProcess(id) {
        return this.deleteJson(`/api/ps/entity/${id}`)
    }
    static deleteAllProcess(ids) {
        return this.deleteJson('/api/ps/entity', ids)
    }
    static updateProcess(params) {
        return this.putJson('/api/ps/entity', params)
    }
    static executeService(id, param) {
        return this.postJson(`/api/ps/exe/${id}`, param)
    }
    static getProcessExecuteParams(id) {
        return this.getJson(`/api/ps/params/${id}`)
    }
    static getProcessExecuteParamInfo(id, param) {
        return this.postJson("/api/ps/params/info", {
            id, param
        })
    }
    static getStringParams(string) {
        return this.postJson("/api/ds/params", string)
    }
    static executeExecutor(dsId, executorName, executorParam, executeParams) {
        return this.postJson("/api/ds/executor/exe", {
            dsId,
            executorName,
            executorParam: JSON.stringify(executorParam),
            executeParams
        })
    }
    static executeExecutorAsync(dsId, executorName, executorParam, executeParams) {
        let connected = customGlobal.get('connected');
        if (connected === false) {
            Modal.error({
                title: "提示",
                content: <div>已与消息服务器断开连接，任务将继续执行，但你无法收到反馈消息，请
                    <Button type="link" onClick={e => {
                        window.location.reload();
                    }}>刷新</Button>
                    浏览器重试</div>
            })
        }

        return this.postJson("/api/ds/executor/exe/async", {
            dsId,
            executorName,
            executorParam: JSON.stringify(executorParam),
            executeParams
        })
    }
    // 执行查询
    static executeQuery(queryParam) {
        return this.postJson('/api/ds/exe', {
            dsName: queryParam.dsName,
            exeName: queryParam.exeName,
            param: JSON.stringify(queryParam.queryObj)
        })
    }
    // 获取子节点
    static getMyDataChildren(id) {
        return this.getJson(`/api/storage/data/${id}/children`);
    }
    // 获取子节点
    static getChildren(params) {
        return this.getJson(`/api/ds/children?dsId=${params.dsId}&node=${params.path}`);
    }
    // 获取子节点
    static getMySpace() {
        return this.getJson(`/api/storage/list`)
    }

    static upsertDatasourceMetadata(items) {
        return this.postJson(`/api/ds/meta`, items);
    }
    static getTaskList() {
        return this.getJson("/api/task/list")
    }
    static getTaskAlert(id) {
        return this.getJson(`/api/task/${id}/alert`)
    }
    static stopTask(id) {
        return this.postJson(`/api/task/${id}/stop`)
    }
    static removeTask(ids) {
        return this.postJson('/api/task/remove', ids)
    }
    static getSearchConfig() {
        return this.getJson(`/searchConfig.json`);
    }
    static getServerConfig() {
        return new Promise((resolve) => {
            this.getJson(`/api/config/static`).then(data => {
                this.getActuator().then(resp => {
                    resolve({ ...data, actuator: resp })
                })
            })
        })
    }
    static needLogin(res) {
        return res.type === 'NOLOGIN'
    }
    static needLoginError() {
        return { message: `请先登陆` }
    }
    static responseError(res) {
        // if (res) {
        //     let rawMessage = res.message
        //     if (rawMessage.length > 50) {
        //         rawMessage = "出现异常"
        //         let status = res.status
        //         if (status) {
        //             rawMessage += `,状态码:${status}`
        //         }
        //         res.message = rawMessage
        //     }
        // }
        return res
    }
    static connectError(err) {
        return { message: `连接异常:${err.message}` }
    }
    static errorMeaasge(message) {
        return { message: message }
    }

    static getPathChildren(path) {
        return this.getJson('/api/file/children', {
            path: path
        })
    }

    static getTypeOfSource(url) {
        return new Promise((resolve, reject) => {
            this.postJson(url + '/query', {
                fields: ["shape"],
                limit: 1
            }).then(data => {
                let results = parseResultToJson(data) || [];
                if (results[0] && results[0]['shape']) {
                    let shapeText = (results[0]['shape'] || "").toLowerCase();
                    if (shapeText.indexOf('polygon') > -1) {
                        resolve('Polygon');
                    } else if (shapeText.indexOf('linestring') > -1) {
                        resolve('LineString');
                    } else if (shapeText.indexOf('point')) {
                        resolve('Point');
                    } else {
                        reject();
                    }
                } else {
                    reject();
                }
            });
        })
    }

    static getActuator() {
        return FetchHelper.getJson('/api/actuator/info');
    }

    static getDataSourcePrivateCount(searchKey) {
        return this.getJson(`/api/ds/list/mine/count?keyword=${searchKey || ""}`)
    }

    static getDataSourcePrivateList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/ds/list/mine?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getDataSourceProtectedCount(searchKey) {
        return this.getJson(`/api/ds/list/share/count?keyword=${searchKey || ""}`)
    }

    static getDataSourceProtectedList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/ds/list/share?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getDataSourceAllCount(searchKey) {
        return this.getJson(`/api/ds/list/count?keyword=${searchKey || ""}`)
    }

    static getDataSourcePublicCount(searchKey) {
        return this.getJson(`/api/ds/list/public/count?keyword=${searchKey || ""}`)
    }

    static getDataSourcePublicList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/ds/list/public?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getScriptService(id) {
        return this.getJson(`/api/entity/${id}`);
    }

    static getScriptServiceAllCount(searchKey) {
        return this.getJson(`/api/ps/list/count?keyword=${searchKey || ""}`)
    }

    static getScriptServicePublicCount(searchKey) {
        return this.getJson(`/api/ps/list/public/count?keyword=${searchKey || ""}`)
    }

    static getScriptServicePublicList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/ps/list/public?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getScriptServiceSharedCount(searchKey) {
        return this.getJson(`/api/ps/list/share/count?keyword=${searchKey || ""}`)
    }

    static getScriptServiceSharedList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/ps/list/share?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getScriptServicePrivateCount(searchKey) {
        return this.getJson(`/api/ps/list/mine/count?keyword=${searchKey || ""}`)
    }

    static getScriptServicePrivateList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/ps/list/mine?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }







    static getMyDataAllCount(searchKey) {
        return this.getJson(`/api/storage/list/count?keyword=${searchKey || ""}`)
    }
    static getMyDataPublicCount(searchKey) {
        return this.getJson(`/api/storage/list/public/count?keyword=${searchKey || ""}`)
    }

    static getMyDataPublicList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/storage/list/public?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getMyDataSharedCount(searchKey) {
        return this.getJson(`/api/storage/list/share/count?keyword=${searchKey || ""}`)
    }

    static getMyDataSharedList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/storage/list/share?size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }

    static getMyDataPrivateCount(searchKey) {
        return this.getJson(`/api/storage/list/mine/count?keyword=${searchKey || ""}`)
    }

    static getMyDataPrivateList(pageIndex, pageSize, searchKey) {
        return this.getJson(`/api/storage/list/mine?desc=1&order=modify_time&size=${pageSize}&page=${pageIndex}&keyword=${searchKey || ""}`)
    }


    static createTableToMyData(meta) {
        return this.postJson("/api/storage/create", meta);
    }

    static createTableIndexToMyData(id, field, rebuild) {
        return this.postJson(`/api/storage/data/${id}/index`,
            {
                field: field,
            });
    }

}
export default API